<template>
	<div class="modal">
		<div class="modal-wrap">
			<div class="modal-inner">
				<h2 class="modal-title">{{ searches.length ? 'Update/Save' : 'Save' }} Search<span class="close" @click="close">X</span></h2>

				<div class="modal-inner-scroll">
					<form class="form" @submit.prevent="save">
						<label v-if="searches.length">Select a search to update</label>
						<v-select
							v-if="searches.length"
							v-model="selectedSearch"
							:options="searchOptions"
							label="name"
							:clearable="true"
						/>

						<FormInput
							type="text"
							:label="searches.length ? 'or Name a new one' : 'Search Name'"
							v-model="searchName"
							name="searchName"
							:errors="errors"
							@has-internal-errors="hasInternalErrors"
							v-if="!selectedSearch"
						/>

						<p class="error" v-if="typeof errors === 'string' && errors !== ''" v-html="errors" />

						<span class="large-button full no-margin" @click="save">{{ selectedSearch ? 'Update' : 'Save' }}</span>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ApiService from './../../services/api.service'
	import FormInput from "./../Form/Input.vue";
	import VSelect from 'vue-select';

	export default {
		name: "SaveSearchModal",

		components: {
			FormInput,
			VSelect,
		},

		props: {
			search: {
				type: Object,
				required: true,
			},
			sort: {
				type: Object,
				required: true
			},
			savedSearchType: {
				type: String
			},
			searches: {
				type: Array,
				required: true
			}
		},

		data() {
			return {
				searchName: "",
				selectedSearch: null,
				errors: {},
				okToSubmit: true,
			};
		},

		computed: {
			searchOptions() {
				return this.searches.map(search => ({
					_id: search._id.toString(),
					name: search.name
				}));
			}
		},

		methods: {
			save() {
				if (!this.okToSubmit || ( !this.searchName && !this.selectedSearch )) {
					if (!this.searchName) {
						this.$snotify.error("Please enter a name for your search");
					}
					return;
				}

				const endpoint = this.selectedSearch 
					? `saved-searches/${this.savedSearchType}/${this.selectedSearch._id}`
					: `saved-searches/${this.savedSearchType}`;
				
				const method = this.selectedSearch ? 'put' : 'post';

				ApiService[method](endpoint, {
					filters: this.search,
					sort: this.sort,
					name: this.searchName,
					type: this.savedSearchType
				})
					.then(() => {
						this.$snotify.success(this.selectedSearch ? "Search updated successfully" : "Search saved successfully");
						this.$emit("saved");
						this.close();
					})
					.catch((err) => {
						this.$snotify.error(this.selectedSearch ? "Failed to update search" : "Failed to save search");
					});
			},

			close($event) {
				if ($event) $event.preventDefault();
				this.searchName = "";
				this.selectedSearch = null;
				this.errors = {};
				this.$emit("close");
			},

			hasInternalErrors(a) {
				if (typeof this.errors[a.name] !== "undefined") delete this.errors[a.name];

				if (a.error) this.errors[a.name] = a.error;

				this.okToSubmit = true;

				Object.keys(this.errors).forEach(function(error) {
					this.okToSubmit = false;
				});
			},
		},
	};
</script>

<style lang="less" scoped>
label {
	padding-bottom: 8px;
}
</style>
